export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10940.2387f082.jpg";